import { ApiStatus, fetchApiPublic } from "./fetchStudioApi";

export const saveWaveformData = async (
  projectId: string,
  projectMediaId: string,
  waveformData: string,
) => {
  try {
    const data = new FormData();
    data.append("projectId", projectId);
    data.append("projectMediaId", projectMediaId);
    data.append("waveformData", JSON.stringify(waveformData));

    const result = await fetchApiPublic({
      path: "/saveWaveformOnProject",
      method: "POST",
      body: data,
    });

    if (result.status === ApiStatus.SUCCESS) {
      return {
        type: "success",
        value: result.json(),
      };
    } else {
      return {
        type: "error",
      };
    }
  } catch (error) {
    return {
      type: "error",
      error,
    };
  }
};
